export const PIPELINE_SETTINGS_DEFAULTS = {
  max_llm_timeout: 3,
  max_characters_number_per_system_prompt_variable: 100000,
  link_mic_audio: false,
  preemptive_synthesis: true,
  code_box_debug_on: false,
  use_datetime_tool: true,
  use_terminate_call_tool: false,
  trigger_next_agent_response: false,
  silence_triggers: [] as { sec: number; msg: string }[],
  background_audio: {
    enabled: false,
  },
  voicemail_detection: {
    enabled: false,
  },
  ppx_model: 'sonar-pro',
  ppx_temperature: 0.2,
  ppx_timeout_sec: 10,
  ppx_search_context_size: 'medium',
  ppx_max_tokens: 200,
} as const;
